var Interface = {
    currentMusic: null,
    musicLoopID: 0,
    startFocusListener: function () {
        ifvisible.on("blur", function () {
            Interface.pauseMusic();
        });

        ifvisible.on("focus", function () {
            Interface.playMusic();
        });
    },
    playMusic: function (name) {
        if (this.currentMusic === name || !CC.Sound._GLOBAL_IS_WEB_AUDIO_SUPPORTED)
            return;
        if (name) {
            this.stopMusic();
            this.currentMusic = name;

        }
        else {
            name = this.currentMusic;
        }
        if(!name || name=="")return;
        var self = this;
        sound.play(self.currentMusic);
        if (this.musicLoopID) {
            clearInterval(this.musicLoopID);
        }
        this.musicLoopID = setInterval(function () {
            sound.play(self.currentMusic);
        }, sound._sprites[name][1] * 1000);
    },
    pauseMusic: function () {
        sound.stop();
        clearInterval(this.musicLoopID);
    },
    stopMusic: function () {
        sound.stopSound(this.currentMusic);
        this.currentMusic = null;
        clearInterval(this.musicLoopID);
    },
    mute: function () {
        sound.mute();
        this.pauseMusic();
    },
    unmute: function (replayMusic) {
        sound.unmute();
        if (replayMusic && this.currentMusic) {
            this.playMusic();
        }
    },
    text: function (copy, size, align, maxedWidth, noShadow) {
        maxedWidth = maxedWidth || 0;
        var text = new PIXI.Container();
        text.align = align;
        var textOutside = new PIXI.Text(copy, {
            font: size + "px fred_burger_shadow",
            align: "center",
            fill: 0x000000,
            padding: 10,
            lineHeight: size * 1.22,
            wordWrap: !!maxedWidth,
            wordWrapWidth: maxedWidth
        });
        var textInside = new PIXI.Text(copy, {
            font: size + "px fred_burger",
            align: "center",
            fill: 0xFFFFFF,
            stroke: "#672d68",
            strokeThickness: size * 0.25,
            lineHeight: size * 1.22,
            miterLimit: 2,
            padding: 10,
            wordWrap: !!maxedWidth,
            wordWrapWidth: maxedWidth
        });

        textOutside.maxWidth = maxedWidth;
        textInside.maxWidth = maxedWidth;
        textInside.maxWidth = maxedWidth;
        textOutside.updateText();
        textInside.updateText();
        textOutside.x = Math.floor(textOutside.width * -0.5);
        textInside.x = Math.floor(textInside.width * -0.5);
        textOutside.y = Math.floor(textOutside.height * -0.5) - size * 0.2;
        textInside.y = Math.floor(textInside.height * -0.5);
        text.setText = function (copy) {
            copy = copy || textOutside.text;
            textOutside.text = copy;
            textInside.text = copy;
            textOutside.updateText();
            textInside.updateText();
            textOutside.x = Math.floor(textOutside.width * -0.5);
            textInside.x = Math.floor(textInside.width * -0.5);
            textOutside.y = Math.floor(textOutside.height * -0.5) - size * 0.2;
            textInside.y = Math.floor(textInside.height * -0.5);
        };
        if (!noShadow) {
            text.addChild(textOutside);
        }
        text.addChild(textInside);
        // text.setText(copy);
        return text;
    },
    reverseText: function (copy, size, align, maxedWidth, noShadow) {
        maxedWidth = maxedWidth || 0;
        var text = new PIXI.Container();
        text.align = align;
        var textOutside = new PIXI.Text(copy, {
            font: size + "px fred_burger_shadow",
            align: align,
            fill: 0xFFFFFF,
            lineHeight: size * 1.22,
            wordWrap: !!maxedWidth,
            wordWrapWidth: maxedWidth
        });
        var textInside = new PIXI.Text(copy, {
            font: size + "px fred_burger",
            align: align,
            fill: 0x000000,
            stroke: "#FFFFFF",
            strokeThickness: size * 0.25,
            lineHeight: size * 1.22,
            miterLimit: 2,
            wordWrap: !!maxedWidth,
            wordWrapWidth: maxedWidth
        });

        textOutside.maxWidth = maxedWidth;
        textInside.maxWidth = maxedWidth;
        textInside.maxWidth = maxedWidth;
        textOutside.updateText();
        textInside.updateText();
        textOutside.x = Math.floor(textOutside.width * -0.5);
        textInside.x = Math.floor(textInside.width * -0.5);
        textOutside.y = Math.floor(textOutside.height * -0.5) - size * 0.2;
        textInside.y = Math.floor(textInside.height * -0.5);
        text.setText = function (copy) {
            copy = copy || textOutside.text;
            textOutside.text = copy;
            textInside.text = copy;
            textOutside.updateText();
            textInside.updateText();
            textOutside.x = Math.floor(textOutside.width * -0.5);
            textInside.x = Math.floor(textInside.width * -0.5);
            textOutside.y = Math.floor(textOutside.height * -0.5) - size * 0.2;
            textInside.y = Math.floor(textInside.height * -0.5);
        };
        if (!noShadow) {
            text.addChild(textOutside);
        }
        text.addChild(textInside);
        // text.setText(copy);
        return text;
    },
    anchorOnTrim: function (sprite, anchor) {
        anchor = anchor || new PIXI.Point(0.5, 0.5);
        var baseX = sprite.texture.trim?sprite.texture.trim.x:0;
        var baseY = sprite.texture.trim?sprite.texture.trim.y:0;
        var anchorLoci = {
            x: baseX + (anchor.x * sprite.texture.crop.width),
            y: baseY + (anchor.y * sprite.texture.crop.height)
        };
        sprite.x += anchorLoci.x - (sprite.anchor.x * sprite.width);
        sprite.y += anchorLoci.y - (sprite.anchor.y * sprite.height);
        sprite.anchor.x = anchorLoci.x / sprite.width;
        sprite.anchor.y = anchorLoci.y / sprite.height;
    },
    getTimeText: function (milliseconds) {
        var time = new Date(milliseconds);
        return time.toISOString().substring(14, 22);
    }
};